export const RootPrefix = 'order_detail_page';
